import { Injectable } from '@angular/core';

/**
 * Carga del chat de soporte de Zendesk (Zopim).
 *
 * Lo ven todos menos los suscriptos con acceso al asistente, que tienen el
 * asistente de Sismat en esa misma esquina. Antes se cargaba siempre desde
 * index.html, lo que hacía que ambos widgets convivieran en pantalla.
 */
@Injectable({
  providedIn: 'root'
})
export class ZendeskService {
  private static readonly SCRIPT_ID = 'zopim-widget';
  private static readonly SRC = '//v2.zopim.com/?33myYay8uRoOZMqZsQirh9xgXoMoSzeO';

  private loaded = false;

  /** Inyecta el widget si todavía no está. */
  load(): void {
    if (this.loaded || document.getElementById(ZendeskService.SCRIPT_ID)) {
      this.show();
      return;
    }

    const script = document.createElement('script');
    script.id = ZendeskService.SCRIPT_ID;
    script.type = 'text/javascript';
    script.async = true;
    script.charset = 'utf-8';
    script.src = ZendeskService.SRC;

    document.head.appendChild(script);
    this.loaded = true;
  }

  /**
   * Oculta el widget.
   *
   * El script de Zopim no se puede "descargar" una vez inyectado, así que se
   * usa su propia API para esconderlo. Si el usuario inicia sesión en la misma
   * carga de página, esto es lo que lo saca de pantalla.
   */
  hide(): void {
    const zopim = (window as any).$zopim;

    if (zopim?.livechat?.hideAll) {
      try {
        zopim.livechat.hideAll();
      } catch {
        // El widget puede no estar listo todavía; no es crítico.
      }
    }
  }

  private show(): void {
    const zopim = (window as any).$zopim;

    if (zopim?.livechat?.button?.show) {
      try {
        zopim.livechat.button.show();
      } catch {
        // idem
      }
    }
  }
}
